<template>
  <div>
    <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
    <Table v-else :fields="fields" :items="approvalHistory" type="List" :filtered="filtered" :loading="isLoading" :noHeader="true" />

  </div>
</template>

<script>
import Table from '@/components/Table'
import i18n from '@/plugins/i18n';

let fields = [
  { key: "User", label: i18n.t('customer.approvement.user'), keys: ["User", "username"] },
  { key: "Comment", label: i18n.t('customer.approvement.desc'), keys: ["Comment"] },
  { key: "CreatedAt", label: i18n.t('customer.approvement.date'), type:"date", keys: ["CreatedAt"] },
  { key: "is_approve", label: i18n.t('customer.approvement.state'), type:"badge", keys: ["IsApprove"] },
];

let filtered = ["is_approve", "Comment", "CreatedAt", "User"];

export default {
  name: "ApprovalHistory",
  components: { Table },
  data() {
    return {
      fields, filtered
    }
  },
  props: {
    data: Object,
    modalName: String,
    modalEvent: Function,
    save: Boolean,
    saveState: Function,
    formName: String,
  },
  computed: {
    approvalHistory() {
      return this.$store.getters.getApprovalHistory
    },
    isLoading() {
      return this.$store.getters.getCustomerLoading
    }
  },
  watch: {
    save(){
      this.saveState(false)
      this.modalEvent(false)
    },
  },
  created() {
    console.log(this.data)
    this.$store.dispatch('customerApprovalHistory', this.data.ID)
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/General/Customer/modals/ApprovalHistory.vue